// import Firebase from 'firebase'
// import jwtDecode from 'jwt-decode'
// import router from '@/router'

export default {
  namespaced: true,
  state: {
    platforms: [],
    wizardAnswers: null,
    // wizardPlatforms: null,
    isPlatformsPristine: false,
    filteredPlatforms: []
  },
  mutations: {
    SET_WIZARD_ANSWERS (state, wizardAnswers) {
      state.wizardAnswers = Object.assign({}, wizardAnswers)
    },
    CLEAR_WIZARD_ANSWERS (state) {
      state.wizardAnswers = null
    },
    LOAD_PLATFORMS (state, platforms) {
      state.platforms = platforms
    },
    SET_FILTERED_PLATFORMS (state, filteredPlatforms) {
      state.filteredPlatforms = filteredPlatforms
    },
    CLEAR_FILTERED_PLATFORMS (state) {
      state.filteredPlatforms = []
    }
  },
  actions: {
    clearWizard ({ commit }) {
      commit('CLEAR_WIZARD_ANSWERS')
      commit('CLEAR_FILTERED_PLATFORMS')
    },
    setWizardAnswers ({ commit }, wizardAnswers) {
      commit('SET_WIZARD_ANSWERS', wizardAnswers)
      return Promise.resolve()
    },
    clearWizardAnswers ({ commit }) {
      commit('CLEAR_WIZARD_ANSWERS')
      return Promise.resolve('Wizard answer data cleared')
    },
    loadPlatforms ({ commit }, platforms) {
      commit('LOAD_PLATFORMS', platforms)
    },
    clearFilteredPlatforms ({ commit }) {
      commit('CLEAR_FILTERED_PLATFORMS')
    },
    filter ({ commit, state }) {
      console.log(state)

      // filtering
      const filteredPlatforms = state.platforms.filter(platform => {
        console.groupCollapsed(platform.displayName + ' - ' + platform.status)
        console.count(platform.displayName)

        // remove if product hosted
        if (platform.status === 'product_hosted') {
          console.groupEnd(platform.displayName) // end platform group
          return false
        }

        console.groupCollapsed('CHECK PRODUCTS LOOP')
        // check for products according to answers
        const productResults = productLogic(platform, state.wizardAnswers)
        console.groupEnd()

        console.groupCollapsed('CHECK FEATURES LOOP')
        const enrollmentPlansResults = enrollmentPlansLogic(platform, state.wizardAnswers)
        console.groupEnd()

        const buildCaseResults = buildCaseLogic(platform, state.wizardAnswers)

        const employerPaidResults = employerPaidLogic(platform, state.wizardAnswers)

        console.groupEnd(platform.displayName)
        return productResults &&
          buildCaseResults &&
          enrollmentPlansResults &&
          employerPaidResults
      })
      console.table(filteredPlatforms)
      commit('SET_FILTERED_PLATFORMS', filteredPlatforms)
      return Promise.resolve()
    }
  },
  getters: {
    // eslint-disable-next-line no-unneeded-ternary
    isWizardDataAvailable: state => state.wizardAnswers ? true : false
  }
}

function employerPaidLogic (
  { employerPaidSupport: platformOffer },
  { employerPaidSupport: wizardAnswer }) {
  console.groupCollapsed('Employer Paid Logic')
  console.log('platformOffer: ', platformOffer)
  console.log('wizardAnswer: ', wizardAnswer)
  console.groupEnd()
  return answerCheck(!!platformOffer, !!wizardAnswer)
}

function enrollmentPlansLogic (platform, { features: wizardFeatures }) {
  return Object.keys(wizardFeatures)
    .every(featKey => {
      console.groupCollapsed(featKey)
      if (platform.features && platform.features[featKey]) {
        console.groupEnd()
        return isAnswerSatisfied(platform.features[featKey], wizardFeatures[featKey])
      }
      console.groupEnd()
      return !wizardFeatures[featKey].available
    })
}

function productLogic (platform, { products: wizardProducts }) {
  return Object.keys(wizardProducts)
    .every(prodKey => {
      console.groupCollapsed(prodKey)
      if (platform.products && platform.products[prodKey]) {
        return isAnswerSatisfied(platform.products[prodKey],
          wizardProducts[prodKey]) &&
            ageBandingLogic(platform, prodKey)
      }
      console.groupEnd()
      return !wizardProducts[prodKey].supported
    })
}

function buildCaseLogic (
  { // destructured from platform Object
    buildCaseBrokerIntegratedPartner: platformBIP,
    buildCaseColonialLifeOffice: platformCLO
  },
  { // destructured from wizardAnswer Object
    buildCaseBrokerIntegratedPartner: wizardAnswerBIP,
    buildCaseColonialLifeOffice: wizardAnswerCLO
  }) {
  console.groupCollapsed('HOW DO YOU PLAN TO ENROLL')

  let isBrokerIntegratedPartner = answerCheck(!!platformBIP, !!wizardAnswerBIP)
  console.group('Is Broker or Integrated Partner?')
  console.log(isBrokerIntegratedPartner)
  console.groupEnd()

  let isColonialLifeOffice = answerCheck(!!platformCLO, !!wizardAnswerCLO)
  console.group('Is Colonial Life Office?')
  console.log(isColonialLifeOffice)
  console.groupEnd()

  console.groupEnd()
  return isBrokerIntegratedPartner && isColonialLifeOffice
}

function ageBandingLogic (platform, prodKey) {
  console.group('SATISFIED, DETAIL LOGIC NOW')
  switch (prodKey) {
    case 'group_disability':
    case 'group_hospital_indemnity':
    case 'group_specified_disease':
    case 'group_term_life':
    case 'hospital_confinement':
    case 'term_life':
      console.count('AGE BANDING TRUE!')
      console.groupEnd()
      console.groupEnd()
      return !!platform.ageBanding
    default:
      console.groupEnd()
      console.groupEnd()
      return true
  }
}

function isAnswerSatisfied (obj, answers) {
  return Object.keys(answers).every(function (answerKey) {
    console.groupCollapsed('isAnswerSatisfied')
    console.info(obj)
    console.log(answerKey)
    console.log(answers[answerKey])
    console.groupEnd()
    return answerCheck(propExistsTruthy(obj, answerKey), answers[answerKey])
  })
}

function answerCheck (prop, answer) {
  return answer ? prop : true
}

function propExistsTruthy (obj, prop) {
  if (obj) {
    if (obj[prop] === 'unknown') {
      return false
    }
  }
  return obj ? !!obj[prop] : false
}



// WEBPACK FOOTER //
// ./src/store/wizard.js